import { render, staticRenderFns } from "./ChangeExpiredPassword.vue?vue&type=template&id=bbde01d2&"
import script from "./ChangeExpiredPassword.vue?vue&type=script&lang=js&"
export * from "./ChangeExpiredPassword.vue?vue&type=script&lang=js&"
import style0 from "./ChangeExpiredPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports